import { anyErrorFrameMatches } from './utils';

// Potentially related to https://code.google.com/archive/p/google-web-toolkit/issues/1488
// (linked from https://groups.google.com/g/google-web-toolkit/c/Wi8pMnCtF18)
// Likely never being fixed, and just as likely we're never updating GWT again, so ignoring:
const isGwtIframeContentWindowError = error =>
  error.type === 'TypeError' &&
  error.value?.endsWith('.contentWindow is null') &&
  anyErrorFrameMatches(
    error,
    // The actual filename will look more like:
    // https://fake.xmatters.com/static/includes/gwt/application/application.nocache.js?r=49885&h=031ee346bcd
    frame =>
      frame.filename?.includes(
        '/static/includes/gwt/application/application.nocache.js',
      ),
  );

// Sentry data for these errors isn't useful. Splunk contains more useful info:
const isGwtJsError = error =>
  error.value?.startsWith(
    'Non-Error exception captured with keys: __gwt$backingJsError',
  );

// We've wrapped our own accesses to sizeColumnsToFit in a try/catch,
// the remaining ones are instances of https://github.com/ag-grid/ag-grid/issues/5532
const isAgGridInternalError = error =>
  error.value?.includes("reading 'sizeColumnsToFit'");

export default function shouldFilterError(error) {
  return (
    isGwtIframeContentWindowError(error) ||
    isGwtJsError(error) ||
    isAgGridInternalError(error)
  );
}
